<template>
  <div>
    <Nuevo
      :dialog="dialog"
      :Item="itemSelected"
      :Years="Years"
      v-if="dialog"
      @closeDialog="closeDialog"
      ref="nuevo"
    />
    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal estilo Inspección / Cliente -->
      <v-toolbar height="58" color="secondary" dark flat class="px-3">
        <div class="d-flex align-center">
          <v-icon left>mdi-tune-vertical</v-icon>
          <span class="text-h6 font-weight-medium">
            {{ Titulo || "Criterios de Aceptación" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
            style="font-size: 0.95rem; height: 32px"
          >
            <v-icon left size="18" color="secondary">mdi-counter</v-icon>
            {{ Items ? Items.length : 0 }} Criterios
          </v-chip>
          <v-chip
            v-if="Indicador"
            small
            color="indigo lighten-4"
            text-color="indigo darken-4"
            class="font-weight-bold ml-2 px-3 elevation-1 d-none d-sm-inline-flex"
            style="font-size: 0.9rem; height: 32px"
          >
            <v-icon left size="16" color="indigo darken-3">mdi-chart-line</v-icon>
            {{ Indicador }}
          </v-chip>
        </div>

        <v-spacer></v-spacer>

        <!-- Botón de Ayuda -->
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mx-1 btn-circle-tooltip"
              icon
              dark
              target="_blank"
              :href="global.helpdesk_url + 'criterio_aceptacion'"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
            </v-btn>
          </template>
          <span>¿Necesitas ayuda?</span>
        </v-tooltip>
      </v-toolbar>

      <!-- Sección de Búsqueda y Acciones -->
      <div class="pa-4 pb-2">
        <v-row dense class="align-center mb-1">
          <!-- Búsqueda Rápida -->
          <v-col cols="12" md="6" lg="7">
            <v-text-field
              v-model="search"
              outlined
              dense
              single-line
              hide-details
              prepend-inner-icon="mdi-magnify"
              clearable
              label="Búsqueda rápida"
              placeholder="Buscar por modelo, medida, ID..."
              class="rounded-lg"
            ></v-text-field>
          </v-col>

          <!-- Botones de Acción -->
          <v-col cols="12" md="6" lg="5" class="d-flex align-center justify-end flex-wrap gap-2">
            <!-- Descargar Excel -->
            <v-btn
              v-if="Excel"
              color="success"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg mr-2"
              @click="DescargarExcel()"
            >
              <v-icon left size="18">mdi-file-excel</v-icon>
              Descargar Tabla
            </v-btn>

            <!-- Botón Nuevo Criterio -->
            <v-btn
              v-if="global._autorizacion_usuario(Permisos, $route.meta.id, ['2'])"
              color="primary"
              dark
              height="38"
              class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
              @click="nuevoItem()"
            >
              <v-icon left size="20">mdi-plus-circle</v-icon>
              Nuevo Criterio
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Tabla Principal -->
      <div class="table-responsive-wrapper">
        <v-data-table
          dense
          :headers="filteredCabecera"
          :items="Items"
          :items-per-page="10"
          :search="search"
          class="modern-table elevation-0"
          loading-text="Cargando criterios de aceptación... Por favor, espere"
          no-data-text="No hay criterios de aceptación disponibles"
          :loading="Loading"
          :footer-props="{
            'items-per-page-text': 'Resultados por página:',
            'items-per-page-options': [5, 10, 25, 50],
            'page-text': '{0}-{1} de {2}'
          }"
        >
          <!-- Columna Acciones -->
          <template v-slot:[`item.acciones`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="26"
                    width="26"
                    color="blue lighten-1"
                    fab
                    x-small
                    dark
                    class="action-btn elevation-1"
                    @click="editarItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon x-small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar Criterio</span>
              </v-tooltip>
            </div>
          </template>

          <!-- Columna ID -->
          <template v-slot:[`item.id`]="{ item }">
            <span class="font-weight-bold font-mono text--secondary">
              #{{ item.id }}
            </span>
          </template>

          <!-- Columna Modelo -->
          <template v-slot:[`item.modelo`]="{ item }">
            <span class="font-weight-medium text-body-2 text--primary">
              {{ item.modelo || '-' }}
            </span>
          </template>

          <!-- Columna Medida -->
          <template v-slot:[`item.medida`]="{ item }">
            <v-chip x-small color="grey lighten-4" class="font-weight-bold" text-color="grey darken-3">
              {{ item.medida || '-' }}
            </v-chip>
          </template>

          <!-- Columna Criterio Superior (Objetivo) -->
          <template v-slot:[`item.criterio_superior`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-chip small color="white" text-color="green darken-3" class="font-weight-bold elevation-1">
                <v-icon left x-small color="green darken-2">mdi-check-circle</v-icon>
                {{ item.criterio_superior }}
              </v-chip>
            </div>
          </template>

          <!-- Columna Tolerable Máximo -->
          <template v-slot:[`item.rango_c_superior`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-chip small color="white" text-color="amber darken-4" class="font-weight-bold elevation-1">
                {{ item.rango_c_superior }}
              </v-chip>
            </div>
          </template>

          <!-- Columna Tolerable Mínimo -->
          <template v-slot:[`item.rango_c_inferior`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-chip small color="white" text-color="amber darken-4" class="font-weight-bold elevation-1">
                {{ item.rango_c_inferior }}
              </v-chip>
            </div>
          </template>

          <!-- Columna Criterio Inferior (Deficiente) -->
          <template v-slot:[`item.criterio_inferior`]="{ item }">
            <div class="d-flex align-center justify-center">
              <v-chip small color="white" text-color="red darken-3" class="font-weight-bold elevation-1">
                <v-icon left x-small color="red darken-2">mdi-alert-circle</v-icon>
                {{ item.criterio_inferior }}
              </v-chip>
            </div>
          </template>

          <!-- Columna Criterio de Aceptación General -->
          <template v-slot:[`item.criterioaceptacion`]="{ item }">
            <div class="d-flex flex-column align-center justify-center py-1">
              <v-chip
                x-small
                color="green darken-1"
                text-color="white"
                class="font-weight-bold my-1 elevation-1 chip-criterio-fila"
              >
                Obj: {{ item.criterio_superior }}
              </v-chip>
              <v-chip
                x-small
                color="amber darken-2"
                text-color="white"
                class="font-weight-bold my-1 elevation-1 chip-criterio-fila"
              >
                Tol: [{{ item.rango_c_inferior }} - {{ item.rango_c_superior }}]
              </v-chip>
              <v-chip
                x-small
                color="red darken-1"
                text-color="white"
                class="font-weight-bold my-1 elevation-1 chip-criterio-fila"
              >
                Def: {{ item.criterio_inferior }}
              </v-chip>
            </div>
          </template>
        </v-data-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import Nuevo from './nuevo.vue';
import exportFromJSON from 'export-from-json';
import MensajeTransicion from '../Alerta.vue';
import global from '@/global';

export default {
  props: ['Titulo', 'Cabecera', 'Items', 'Excel', 'Crear', 'Years', 'Loading'],
  components: {
    Nuevo,
    MensajeTransicion
  },
  data() {
    return {
      search: '',
      dialog: false,
      itemSelected: {},
      mayor: '<',
      menor: '<',
      mensaje: '',
      verAlerta: false,
      global: global
    };
  },
  computed: {
    ...mapState('navigation', ['Permisos']),
    ...mapGetters('criterioaceptacion', ['Indicador', 'Año']),
    canShowAccionColumn() {
      return global._autorizacion_usuario(this.Permisos, this.$route.meta.id, ['3', '4']);
    },
    filteredCabecera() {
      return this.Cabecera
        .filter(col => !(col.value === 'acciones' && !this.canShowAccionColumn))
        .map(col => {
          let cellClass = col.cellClass || '';
          let headerClass = col.class || '';

          if (col.value === 'criterio_superior') {
            cellClass = `${cellClass} col-criterio-superior text-center`.trim();
            headerClass = `${headerClass} th-criterio-superior`.trim();
          } else if (col.value === 'rango_c_superior') {
            cellClass = `${cellClass} col-tolerable-max text-center`.trim();
            headerClass = `${headerClass} th-tolerable-max`.trim();
          } else if (col.value === 'rango_c_inferior') {
            cellClass = `${cellClass} col-tolerable-min text-center`.trim();
            headerClass = `${headerClass} th-tolerable-min`.trim();
          } else if (col.value === 'criterio_inferior') {
            cellClass = `${cellClass} col-criterio-inferior text-center`.trim();
            headerClass = `${headerClass} th-criterio-inferior`.trim();
          }

          return {
            ...col,
            cellClass,
            class: headerClass
          };
        });
    }
  },
  methods: {
    nuevoItem() {
      this.itemSelected = {
        id: null,
        costoindicador: this.Indicador,
        modelomedida: '',
        anio: this.Año
      };
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.nuevo) {
          this.$refs.nuevo.cargarFormulario(this.itemSelected);
        }
      });
    },

    editarItem(item) {
      this.itemSelected = {
        id: item.id,
        costoindicador: this.Indicador,
        modelomedida: '',
        criterioobjetivo: item.criterio_superior,
        tolerablemaximo: item.rango_c_superior,
        tolerableminimo: item.rango_c_inferior,
        criteriodeficiente: item.criterio_inferior
      };
      this.dialog = true;
      this.$nextTick(() => {
        if (this.$refs.nuevo) {
          this.$refs.nuevo.cargarFormulario(this.itemSelected);
        }
      });
    },

    closeDialog() {
      this.dialog = false;
    },

    DescargarExcel() {
      const data = this.Items;
      const nombreArchivo = 'criterios_aceptacion_' + new Date().toISOString().slice(0, 10);
      const exportType = exportFromJSON.types.xls;
      exportFromJSON({
        data,
        nombreArchivo,
        exportType
      });
    }
  }
};
</script>

<style scoped>
.modern-table ::v-deep thead tr:not(.v-data-table__progress) th {
  background-color: #424242 !important;
  color: #ffffff !important;
  font-size: 0.84rem !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px;
  white-space: nowrap;
  height: 44px !important;
  border-bottom: none !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th .v-icon {
  color: #ffffff !important;
}

.modern-table ::v-deep thead tr:not(.v-data-table__progress) th:hover {
  background-color: #333333 !important;
}

.modern-table ::v-deep thead tr.v-data-table__progress th {
  background: transparent !important;
  border: none !important;
  padding: 0 !important;
  height: auto !important;
}

.modern-table ::v-deep .v-data-table__empty-wrapper td {
  background: transparent !important;
  background-color: transparent !important;
}

.modern-table ::v-deep td {
  font-size: 0.85rem !important;
  padding: 10px 14px !important;
  border-bottom: 1px solid #f1f5f9 !important;
  vertical-align: middle;
}

.modern-table ::v-deep tbody tr:hover {
  background-color: #f8fafc !important;
  transition: background-color 0.15s ease-in-out;
}

/* Fondos y dimensiones para Columnas de Criterios y Rangos */
.modern-table ::v-deep th.th-criterio-superior,
.modern-table ::v-deep th.th-tolerable-max,
.modern-table ::v-deep th.th-tolerable-min,
.modern-table ::v-deep th.th-criterio-inferior {
  white-space: normal !important;
  line-height: 1.25 !important;
  font-size: 0.78rem !important;
  padding: 6px 4px !important;
  text-align: center !important;
  vertical-align: middle !important;
}

.modern-table ::v-deep th.th-criterio-superior {
  background-color: #2e7d32 !important;
  color: #ffffff !important;
  border-left: 1px solid rgba(255, 255, 255, 0.2) !important;
  width: 110px !important;
  max-width: 110px !important;
}

.modern-table ::v-deep th.th-tolerable-max {
  background-color: #b45309 !important;
  color: #ffffff !important;
  border-left: 1px solid rgba(255, 255, 255, 0.2) !important;
  width: 105px !important;
  max-width: 105px !important;
}

.modern-table ::v-deep th.th-tolerable-min {
  background-color: #b45309 !important;
  color: #ffffff !important;
  width: 105px !important;
  max-width: 105px !important;
}

.modern-table ::v-deep th.th-criterio-inferior {
  background-color: #c62828 !important;
  color: #ffffff !important;
  border-left: 1px solid rgba(255, 255, 255, 0.2) !important;
  width: 110px !important;
  max-width: 110px !important;
}

.modern-table ::v-deep td.col-criterio-superior {
  background-color: #e8f5e9 !important;
  border-left: 1px solid #c8e6c9 !important;
  border-right: 1px solid #c8e6c9 !important;
  padding: 6px 4px !important;
  width: 110px !important;
  max-width: 110px !important;
}

.modern-table ::v-deep td.col-tolerable-max {
  background-color: #fff8e1 !important;
  border-left: 1px solid #ffecb3 !important;
  padding: 6px 4px !important;
  width: 105px !important;
  max-width: 105px !important;
}

.modern-table ::v-deep td.col-tolerable-min {
  background-color: #fff8e1 !important;
  border-right: 1px solid #ffecb3 !important;
  padding: 6px 4px !important;
  width: 105px !important;
  max-width: 105px !important;
}

.modern-table ::v-deep td.col-criterio-inferior {
  background-color: #ffebee !important;
  border-left: 1px solid #ffcdd2 !important;
  border-right: 1px solid #ffcdd2 !important;
  padding: 6px 4px !important;
  width: 110px !important;
  max-width: 110px !important;
}

/* Efectos al pasar el cursor (Hover) */
.modern-table ::v-deep tbody tr:hover td.col-criterio-superior {
  background-color: #c8e6c9 !important;
}

.modern-table ::v-deep tbody tr:hover td.col-tolerable-max,
.modern-table ::v-deep tbody tr:hover td.col-tolerable-min {
  background-color: #ffecb3 !important;
}

.modern-table ::v-deep tbody tr:hover td.col-criterio-inferior {
  background-color: #ffcdd2 !important;
}

.modern-table ::v-deep .v-data-footer {
  border-top: 1px solid #e2e8f0;
  background-color: #f8fafc;
  font-size: 0.82rem;
  padding: 8px 16px;
}

.table-responsive-wrapper {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive-wrapper::-webkit-scrollbar {
  height: 6px;
}

.table-responsive-wrapper::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.gap-1 {
  gap: 4px;
}

.font-mono {
  font-family: monospace, 'Courier New', Courier;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

.chip-criterio-fila {
  min-width: 150px;
  max-width: 200px;
  width: 100%;
  justify-content: center !important;
  letter-spacing: 0.3px;
}

.chip-criterio-fila ::v-deep .v-chip__content {
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
  text-align: center !important;
}
</style>
